module.exports = __webpack_public_path__ + "img/loading.0fc2684d.gif";